// extracted by mini-css-extract-plugin
export var editButton = "_o5-0";